import * as _ from "lodash";
import * as moment from "moment";
import angular = require("angular");
import { AttributionRepo } from "../attribution.repo";
import { PortfolioRepo } from "../../../portfolio/portfolio.repo";
import {
  AssetClassPerformance,
  defaultAssetClassPerformances,
} from "../../../portfolio/models/aggregatePortfolioItem";
import * as echarts from "echarts";
import {
  BarChartStyleOption,
  getWaterfallOptions,
} from "../../../common/waterfall-chart-options";
import { TrailingTwelveMonthsPerformance } from "../../reportManagement/models/TrailingTwelveMonthsPerformance";
import {
  defaultAssetClassNames,
  PortfolioAttributionContribution,
} from "../../models/PortfolioAttributionBenchmarkDto ";
import { getNegativeBarGraphOptions } from "../../../common/negative-bar-graph-options";
class AssetCLassAttributionController implements angular.IOnInit {
  //Props passed to component
  public selectedPortfolioIds: Array<number>;
  public selectedCurrency: string;
  public clientPortfolios: any;
  public client: any;

  //Declared instance members
  public isLoading: boolean = false;
  public isFetchingPortfolioAttributions: boolean = false;
  public quarterDates;
  public assetClassPerformanceTTM: AssetClassPerformance[] = [];
  public assetClassPerformanceQuarter: AssetClassPerformance[] = [];
  public portfolioTTM: TrailingTwelveMonthsPerformance;
  public portfolioPerfomanceForQuarter: any;
  public assetClassTtmPerfGraph: any;
  public assetClassQuarterPerfGraph: any;
  public attributionByAssetClassGraph: any;
  public attributionContributions: PortfolioAttributionContribution;
  public attributionByAssetClass: AssetClassPerformance[] = _.cloneDeep(
    defaultAssetClassPerformances
  );
  public contributionByInvestmentTTMTopThree: AssetClassPerformance[] = [];
  public contributionByInvestmentTTMBottomThree: AssetClassPerformance[] = [];
  public contributionByInvestmentQuarterTopThree: AssetClassPerformance[] = [];
  public contributionByInvestmentQuarterBottomThree: AssetClassPerformance[] =
    [];

  /** @ngInject */
  constructor(
    private attributionRepo: AttributionRepo,
    private portfolioRepo: PortfolioRepo,
    private notifyjs: any
  ) {}

  $onInit() {
    this.isLoading = true;
    this.getQuarterDates();
    this.getAssetClassContributionCurrentQuarter();
    this.getAssetClassContributionTTM();
    this.getAttributionByInvestments();
  }

  private getQuarterDates() {
    this.attributionRepo
      .getQuarterDates(moment().format("YYYY-MM-DD"))
      .then((res) => {
        this.quarterDates = res.data as any;
        this.getPortfolioPerformanceForQuarter();
        this.getPortfolioTTM();
      })
      .catch((e) =>
        this.notifyjs(
          "Something went wrong fetching quarter dates, please try again"
        )
      )
      .finally(() => {
        if (this.allDataReturned()) {
          this.isLoading = false;
        }
      });
  }

  private getAssetClassContributionCurrentQuarter() {
    this.attributionRepo
      .getAssetClassContributionCurrentQuarter(
        this.selectedCurrency,
        this.selectedPortfolioIds
      )
      .then((res) => {
        this.assetClassPerformanceQuarter = res.data as AssetClassPerformance[];
      })
      .catch((e) =>
        this.notifyjs(
          "Something went wrong fetching quarter contributions, please try again"
        )
      )
      .finally(() => {
        if (this.allDataReturned()) {
          this.isLoading = false;
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  private getAssetClassContributionTTM() {
    this.attributionRepo
      .getAssetClassContributionTTM(
        this.selectedCurrency,
        this.selectedPortfolioIds
      )
      .then((res) => {
        this.assetClassPerformanceTTM = res.data as AssetClassPerformance[];

        defaultAssetClassNames.forEach((el) => {
          let searchVariable = el.longName;
          if (el.longName === "Cash And Money Market") {
            searchVariable = "Cash";
          }
          if (el.longName === "Alternative Investments") {
            searchVariable = "Alternative Inv";
          }
          let perfTTM = this.assetClassPerformanceTTM.find(
            (x) => x.name === searchVariable
          );
          let attributionTTM = this.attributionByAssetClass.find(
            (x) => x.name === el.longName
          );

          if (perfTTM !== undefined) {
            if (attributionTTM !== undefined) {
              attributionTTM.performance = perfTTM.performance;
            }
          }
        });
      })
      .catch((e) =>
        this.notifyjs(
          "Something went wrong fetching asset class contributions, please try again"
        )
      )
      .finally(() => {
        if (this.allDataReturned()) {
          this.isLoading = false;
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  public getPortfolioTTM() {
    this.portfolioRepo
      .getTrailingTwelveMonthsPerformance(
        this.selectedCurrency,
        this.selectedPortfolioIds,
        this.quarterDates.endDate,
        true
      )
      .then((res) => {
        this.portfolioTTM = res.data;
      })
      .catch((e) =>
        this.notifyjs("Something went wrong fetching ttm, please try again")
      )
      .finally(() => {
        if (this.allDataReturned()) {
          this.isLoading = false;
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  public getPortfolioPerformanceForQuarter() {
    this.portfolioRepo
      .getPortfolioPerformance(
        this.selectedCurrency,
        this.selectedPortfolioIds,
        this.quarterDates.endDate,
        true
      )
      .then((res) => {
        this.portfolioPerfomanceForQuarter = res.data.find(
          (p) => p.portfolioType.name === "Total"
        );
      })
      .catch((e) =>
        this.notifyjs("Something went wrong fetching ttm, please try again")
      )
      .finally(() => {
        if (this.allDataReturned()) {
          this.isLoading = false;
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  private allDataReturned() {
    return (
      this.quarterDates &&
      this.assetClassPerformanceQuarter.length &&
      this.assetClassPerformanceTTM.length &&
      this.portfolioTTM &&
      this.portfolioPerfomanceForQuarter &&
      this.isFetchingPortfolioAttributions === false
    );
  }

  public intitializeTTMGraph() {
    //Initialize TTM Graph
    let labels = this.assetClassPerformanceTTM.map((p) => p.name);
    let performances = this.assetClassPerformanceTTM.map((p) =>
      this.getChartOptionsBarStylingObject(p.performance)
    );
    this.assetClassTtmPerfGraph = echarts.init(
      document.getElementById("asset-class-ttm-contribution")
    );
    this.assetClassTtmPerfGraph.setOption(
      getWaterfallOptions(labels, performances)
    );
  }

  public intitializeQuarterGraph() {
    //Initialize TTM Graph
    let labels = this.assetClassPerformanceQuarter.map((p) => p.name);
    let performances = this.assetClassPerformanceQuarter.map((p) =>
      this.getChartOptionsBarStylingObject(p.performance)
    );
    this.assetClassQuarterPerfGraph = echarts.init(
      document.getElementById("asset-class-quarter-contribution")
    );
    this.assetClassQuarterPerfGraph.setOption(
      getWaterfallOptions(labels, performances)
    );
  }

  getChartOptionsBarStylingObject(value: number) {
    if (value > 0)
      return new BarChartStyleOption(
        Math.round((value * 100 + Number.EPSILON) * 100) / 100,
        "#b2d979"
      );
    else
      return new BarChartStyleOption(
        Math.round((value * 100 + Number.EPSILON) * 100) / 100,
        "#ed432c"
      );
  }

  public intitializeAttributionByAssetClassGraph() {
    this.attributionByAssetClassGraph = echarts.init(
      document.getElementById("attribution-by-asset-class")
    );
    this.attributionByAssetClassGraph.setOption(
      getNegativeBarGraphOptions(this.attributionByAssetClass)
    );
  }

  public getAttributionByInvestments() {
    this.isFetchingPortfolioAttributions = true;
    const variables = _.cloneDeep(defaultAssetClassNames);

    this.attributionRepo
      .getPortfolioAttributionByInvestment(
        this.client.clientNumber,
        this.selectedPortfolioIds,
        this.selectedCurrency
      )
      .then((res) => {
        this.attributionContributions =
          res.data as PortfolioAttributionContribution;
        variables.forEach((el) => {
          let perf = 0;
          if (
            !!this.attributionContributions.assetClassBenchmarkPerformance[
              el.dtoName
            ]
          ) {
            perf =
              this.attributionContributions.assetClassBenchmarkPerformance[
                el.dtoName
              ];
          }
          let attributionTTM = this.attributionByAssetClass.find(
            (x) => x.name === el.longName
          );
          attributionTTM.benchmarkPerformance = perf;
        });
        this.isFetchingPortfolioAttributions = false;
      })
      .catch((err) => {
        this.notifyjs(
          "Something went wrong fetching attribution by investment, please try again"
        );
      })
      .finally(() => {
        this.isFetchingPortfolioAttributions = false;
        if (this.allDataReturned()) {
          this.isLoading = false;
          this.intitializeQuarterGraph();
          this.intitializeTTMGraph();
          this.intitializeAttributionByAssetClassGraph();
        }
      });
  }

  public calculateTotalPerformance() {
    let total = 0;
    this.attributionByAssetClass.forEach((x) => {
      total += x.performance;
    });
    return total;
  }
}

export const assetClassAttribution: angular.IComponentOptions = {
  template: require("./asset-class-attribution.html"),
  controller: AssetCLassAttributionController,
  bindings: {
    selectedPortfolioIds: "<",
    selectedCurrency: "<",
    clientPortfolios: "<",
    client: "<",
  },
};



// WEBPACK FOOTER //
// ./src/app/portfolioadmin/attribution/asset-class-attribution/asset-class-attribution.ts